<template>
    <div>
        <div class="card">
            <Carousel :value="carteras.getCarterasOperativas" :numVisible="3" :numScroll="3">
                <template #header>
                    <h3 class="titles text-center">Mis Carteras</h3>
                </template>
                <template #item="slotProps">
                    <div class="product-item mb-4">
                        <div class="product-item-content flex flex-column align-items-center">
                            <div class="mb-3 pt-2">
                                <em v-if="!slotProps.data.cartera.displayBagde" :class="slotProps.data.cartera.displayBagde ? 'pi pi-wallet p-text-secondary' : 'pi pi-wallet p-text-secondary badgeNone'" style="font-size: 5rem" />
                                <em v-if="slotProps.data.cartera.displayBagde" v-badge.danger :class="slotProps.data.cartera.displayBagde ? 'pi pi-wallet p-text-secondary' : 'pi pi-wallet p-text-secondary badgeNone'" style="font-size: 5rem" />
                            </div>
                            <div>
                                <h4 class="mb-1 text-center">{{slotProps.data.cartera.nombre}}</h4>
                                <h6 class="mb-1 mt-2 text-center text-xs">{{ slotProps.data.cartera.fechaActualizacion != null ? new Date(slotProps.data.cartera.fechaActualizacion).toLocaleString('es','short') : 'Cartera sin actualizaciones' }}</h6>
                                <div class="car-buttons mt-4 flex justify-content-center">
                                    <Button icon="pi pi-search" 
                                        class="p-button p-button-rounded mr-2"
                                        v-tooltip.bottom="
                                        $t('cartera.misCarteras.verExpedientes')"
                                        @click="listaExpedientes(slotProps.data.cartera)" />
                                    <Button icon="pi pi-replay" 
                                        class="p-button-warning p-button-rounded mr-2"
                                        v-tooltip.bottom="
                                        $t('cartera.misCarteras.actualizarCartera')"
                                        @click="actualizarCartera(slotProps.data.cartera)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Carousel>
        </div>
        <div v-if="verExpedientes">
            <ListadoExpedientesCartera
                :cartera="listarCartera" />
        </div>
    </div>
</template>
<script>

import ListadoExpedientesCartera from "@/components/portal-gran-cliente/Expedientes/ListadoExpedientesCartera.vue";
import { ACTUALIZAR_FECHA_CARTERA } from "@/graphQLQueries/CarterasQueries";

export default {
    name: "MisCarteras",
    components: {
        ListadoExpedientesCartera: ListadoExpedientesCartera,
    },
    data() {
        return {
            carteras: [],
            verExpedientes: false,
            listarCartera: {},
            displayBagde: false,
        }
    },
    mounted() {
        this.carteras = this.$store.getters;
    },
    watch: {
        carteras() {
            this.getBadges();
        }
    },
    methods: {
        actualizarCartera(cartera) {
            this.$apollo
            .mutate({
                mutation: ACTUALIZAR_FECHA_CARTERA,
                variables: {
                    idCartera: cartera.id,
                },
                fetchPolicy: "no-cache",
            })
            .then((data) => {
                this.actualizaFechaCartera(data.data.actualizarFecha)
                this.$toast.add({
                    severity: "success",
                    summary: this.$t("cartera.misCarteras.toast.tituloFecha"),
                    detail: this.$t("cartera.misCarteras.toast.fechaActualizada"),
                    life: 5000,
                });
            })
            .catch(() => {
                this.$toast.add({
                    severity: "error",
                    summary: this.$t("cartera.misCarteras.toast.tituloFechaError"),
                    detail: this.$t("cartera.misCarteras.toast.fechaActualizadaError"),
                    life: 5000,
                });
            });
        },
        listaExpedientes(cartera) {
            this.listarCartera = cartera
            this.verExpedientes = !this.verExpedientes ? true : false;
        },
        getBadges() {
            this.carteras.getCarteras.forEach(cartera => {
                if(cartera.cartera.diasLimiteImpagos != null && cartera.cartera.diasLimiteIncidencias != null) {
                    let days = cartera.cartera.diasLimiteImpagos <= cartera.cartera.diasLimiteIncidencias ? cartera.cartera.diasLimiteImpagos : cartera.cartera.diasLimiteIncidencias
                    let date = new Date(new Date(cartera.cartera.fechaActualizacion).setDate(new Date(cartera.cartera.fechaActualizacion).getDate() + days))
                    if(new Date().getTime() >= date.getTime())
                        cartera.cartera.displayBagde = true
                    else
                        cartera.cartera.displayBagde = false
                }
            });
        },
        actualizaFechaCartera(carteraNueva) {
            this.carteras.getCarteras.forEach(cartera => {
                if(cartera.cartera.id == carteraNueva.id) {
                   cartera.cartera.fechaActualizacion = carteraNueva.fechaActualizacion
                   cartera.cartera.displayBagde = false
                }
            });
        }
    }
}
</script>
<style>
.badgeNone .p-badge {
    display: none !important;
}
</style>